import React from 'react';
import CountUp from 'react-countup';
import { Col, Container, Row } from 'reactstrap';
//import images
import bgImage from '../../assets/images/it/cta.jpg';

const Cta = () => {
  return (
    <React.Fragment>
      <section className="section pt-0">
        <Container>
          <Row className="justify-content-center">
            <Col xs={12}>
              <div
                className="video-solution-cta position-relative"
                style={{ zIndex: '1' }}
              >
                <div
                  className="position-relative py-5 rounded"
                  style={{ background: `url(${bgImage}) top` }}
                >
                  <div
                    className="bg-overlay rounded bg-primary bg-gradient"
                    style={{ opacity: '0.8' }}
                  ></div>

                  <Row>
                    <Col lg={3} xs={6} className="my-4">
                      <div className="counter-box text-center px-lg-4">
                        <i className="uil uil-users-alt text-white-50 h2"></i>
                        <h1 className="mb-0 text-white">
                          <span className="counter-value">
                            <CountUp start={0} end={50} duration={8} />
                          </span>
                          +
                        </h1>
                        <h6 className="counter-head text-white-50">
                          Clientes Felices
                        </h6>
                      </div>
                    </Col>

                    <Col lg={3} xs={6} className="my-4">
                      <div className="counter-box text-center px-lg-4">
                        <i className="uil uil-schedule text-white-50 h2"></i>
                        <h1 className="mb-0 text-white">
                          <span className="counter-value">
                            <CountUp start={0} end={5} duration={8} />
                          </span>
                          +
                        </h1>
                        <h6 className="counter-head text-white-50">
                          Años de Experiencia
                        </h6>
                      </div>
                    </Col>

                    <Col lg={3} xs={6} className="my-4">
                      <div className="counter-box text-center px-lg-4">
                        <i className="uil uil-file-check-alt text-white-50 h2"></i>
                        <h1 className="mb-0 text-white">
                          <span className="counter-value">
                            <CountUp start={0} end={100} duration={8} />
                          </span>
                          +
                        </h1>
                        <h6 className="counter-head text-white-50">
                          Proyectos Completados
                        </h6>
                      </div>
                    </Col>

                    <Col lg={3} xs={6} className="my-4">
                      <div className="counter-box text-center px-lg-4">
                        <i className="uil uil-hard-hat text-white-50 h2"></i>
                        <h1 className="mb-0 text-white">
                          <span className="counter-value">
                            <CountUp start={0} end={20} duration={8} />
                          </span>
                          +
                        </h1>
                        <h6 className="counter-head text-white-50">
                          Expertos
                        </h6>
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </React.Fragment>
  );
};
export default Cta;
